import styled from "@emotion/styled";

export const ForestWrapper = styled.div`
  position: relative;

  // Ensure content above doesn't overlap too much with the mountains
  margin-top: 290px;

  &::before {
    background-image: url(/images/app/mountains-background.svg);
    background-repeat: repeat-x;
    background-position: top;
    position: absolute;
    left: 0;
    content: "";
    width: 100%;

    // Given the mountains go behind other elements of the profile page above
    // the forest. Ensure it is rendered behind them.
    z-index: -1;

    // Show the mountains at a fixed height, directly above the forest
    background-size: 1350px;
    height: 320px;
    top: -320px;

    @media ${(props) => props.theme.bp.mobileUp} {
      background-size: 1600px;
      height: 380px;
      top: -355px;
    }
  }
`;

export const Wrapper = styled.section<{ isForestHidden?: boolean }>`
  background-color: rgb(8, 96, 71);
  color: ${(props) => props.theme.colors.snowdrop};
  min-height: ${(props) => (props.isForestHidden ? "172px" : "400px")};
  overflow: hidden;
  padding: ${(props) => (props.isForestHidden ? "48px 0 0" : "48px 0 80px")};
  text-align: center;

  @media ${(props) => props.theme.bp.mobileUp} {
    min-height: ${(props) => (props.isForestHidden ? "280px" : "400px")};
  }

  div {
    outline: 0;
  }
`;

export const Tuft = styled.div`
  padding: 50px;
  background-image: url("./grass_tuft.png");
  position: absolute;
`;
